import React from "react";
import { DotsLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import { ProjectObjectError } from "./project/ProjectObjectError.jsx";
import { useResolver } from "./Resolver/useResolver.js";

export const Resolver = ({ callback, errorComponent, loadingComponent, children, update }) => {
  const { loading, error } = useResolver(callback, update);

  if (loading) {
    return loadingComponent;
  }

  if (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(error);
    }
    return React.cloneElement(errorComponent, { error });
  }

  return children;
};

Resolver.propTypes = {
  children: PropTypes.any.isRequired,
  callback: PropTypes.func.isRequired,
  errorComponent: PropTypes.element,
  loadingComponent: PropTypes.element,
  update: PropTypes.bool,
};

Resolver.defaultProps = {
  loadingComponent: <DotsLoader />,
  errorComponent: <ProjectObjectError />,
  update: false,
};
